import { Button, Container, Grid, Typography } from "@mui/material";
import Calendario, { ChipCalendario } from "../../../../components/Calendario";
import ScreenBanner from "../../../../components/ScreenBanner";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import { useQuery } from "react-query";
import axiosClient from "../../../../lib/axios";
import { useState } from "react";
import moment, { Moment } from "moment";
import DialogImportarArquivos from "./DialogImportarArquivos";
import groupBy from "../../../../helpers/groupBy";
import DialogDetalharGrupoIntegracao from "./DialogDetalharGrupoIntegracao";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import PermissionGuard from "../../../../components/PermissionGuard";

export default function IntegracaoBancaria() {

    const [diaSelecionado, setDiaSelecionado] = useState(moment());
    const [grupoIntegracaoSelecionado, setGrupoIntegracaoSelecionado] = useState();

    const [openModalImportarArquivo, setOpenModalImportarArquivo] = useState<boolean>(false)
    const [openModalDetalharGrupoIntegracao, setOpenModalDetalharGrupoIntegracao] = useState<boolean>(false)
    const [chips, setChips] = useState<ChipCalendario>({})

    //queries e mutations
    const { isFetching } = useQuery({
        queryKey: ["pesquisar-integracoes-bancarias", diaSelecionado],
        queryFn: () => axiosClient.get("/financeiro/integracao-bancaria/pesquisar-integracoes-bancarias", {
            params: {
                data_arquivo_inicio: diaSelecionado.clone().startOf('month').format('YYYY-MM-DD'),
                data_arquivo_fim: diaSelecionado.clone().endOf('month').format('YYYY-MM-DD')
            }
        }),
        cacheTime: 0,
        onSuccess(data) {

            let chips: ChipCalendario = {};

            if (data?.data.length > 0) {
                let groupedDate = groupBy(data?.data, ({ data_referencia_arquivo }: any) => moment(data_referencia_arquivo).format('YYYY-MM-DD'));

                for (const date in groupedDate) {
                    let groupedType = groupBy(groupedDate[date], ({ tipo }: any) => tipo);

                    for (const type in groupedType) {

                        if (!chips[date]) {
                            chips[date] = [];
                        }

                        let sanitized = groupedType[type].filter((item: any) => item);
                        const statusAguardo = sanitized.some((item: any) => item.status === "Aguardando finalização")
                        const statusPendente = sanitized.some((item: any) => item.status === "Finalizado com pendências" || item.status === "Pendente de gravação em caixas e bancos")

                        chips[date].push({
                            id: 1,
                            label: sanitized.length === 1 ? type : type + ' (' + sanitized.length + ')',
                            icon: statusAguardo ? <PendingOutlinedIcon color="info" /> : statusPendente ? <ErrorOutlineOutlinedIcon color="warning" /> : <CheckCircleOutlineIcon color="success" />,
                            action: () => {
                                setOpenModalDetalharGrupoIntegracao(true);
                                setGrupoIntegracaoSelecionado(sanitized);
                            }
                        });
                    }
                }
            }
            setChips(chips)
        },
    });

    //Funções manipuladoras
    const handleChangeDiaSelecionado = (data: Moment) => {
        setDiaSelecionado(data)
    }

    const handleImportarArquivo = () => {
        setOpenModalImportarArquivo(true)
    }

    const handleExportarArquivo = () => {
    }

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.integracoes-bancarias">

                <Container sx={{ my: 4 }}>
                    <Typography textAlign="center" variant="h5">Integrações bancárias</Typography>

                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12}}>

                            <Calendario
                                {...{ diaSelecionado, isFetching }}
                                alterarDiaSelecionado={(data: Moment) => handleChangeDiaSelecionado(data)}
                                chipCalendario={chips}
                                actionsButtons={[
                                    {
                                        button: <Button
                                            variant="outlined"
                                            color="primary"
                                            startIcon={<FileDownloadIcon />}
                                            onClick={handleImportarArquivo}
                                        >
                                            Importar arquivo
                                        </Button>
                                    },
                                    {
                                        button: <Button
                                            variant="outlined"
                                            color="primary"
                                            disabled={true}
                                            startIcon={<FileUploadIcon />}
                                            onClick={handleExportarArquivo}
                                        >
                                            Exportar arquivo
                                        </Button>
                                    }
                                ]}
                            />

                        </Grid>
                    </Grid>
                </Container>
                {
                    openModalImportarArquivo &&
                    <DialogImportarArquivos
                        {...{ diaSelecionado }}
                        open={openModalImportarArquivo}
                        handleClose={() => setOpenModalImportarArquivo(false)}
                    />
                }

                {
                    openModalDetalharGrupoIntegracao &&
                    <DialogDetalharGrupoIntegracao
                        open={openModalDetalharGrupoIntegracao}
                        grupoIntegracao={grupoIntegracaoSelecionado}
                        handleClose={() => setOpenModalDetalharGrupoIntegracao(false)}
                    />
                }
            </PermissionGuard>
        </>
    )
}
